<template>
  <div class="group-manage-one maxW">
    <div class="crumbs-link">
      <router-link to="/group/manage/selfCreated">圈组管理</router-link>
      <strong>
        <i>></i>当前圈组</strong>
    </div>
    <div class="manage-my-group">
      <div class="manage_nav clear">
        <h3 class="manage_nav_name">
          {{group_name}}
        </h3>
        <div class="manage_nav_btns fr">
          <el-button class="manage_nav_newsBtn" type="primary" size="small" v-if="createId_flag" @click="showNewsDialog(0)">公告发布</el-button>
          <el-dropdown>
            <el-button type="primary" size="small">
              上传教案
            </el-button>
            <el-dropdown-menu slot="dropdown" class="manage_nav_dropdown">
              <el-dropdown-item @click.native="open_dialog(group_id,'v')">关联视频</el-dropdown-item>
              <el-dropdown-item @click.native="open_dialog(group_id,'p')">关联试卷</el-dropdown-item>
              <el-dropdown-item @click.native="open_dialog(group_id,'r')">关联资源</el-dropdown-item>
              <el-dropdown-item @click.native="upload_group_id=group_id">
                <template>
                  <uploader class="uploader-example manage-uploader" v-loading.fullscreen.lock="upload_files_loading" :element-loading-text="'上传中,请勿刷新浏览器...  '+percentage+'%'" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" ref="uploader" :options="uploadOptions" :file-status-text="statusText" @file-added="upload_files_loading=true" @file-progress="fileProgress" @file-success="fileSuccess" @file-error="fileFail">
                    <uploader-unsupport></uploader-unsupport>
                    <uploader-drop>
                      <uploader-btn>本地上传</uploader-btn>
                    </uploader-drop>
                  </uploader>
                </template>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="manage_content clear">
        <template>
          <el-row class="manage_table_title">圈组公告</el-row>
          <el-table :data="newsData" border style="width: 100%" v-loading="n_loading">
            <el-table-column fixed prop="name" label="公告标签" width="260" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="content" label="公告内容" width="518" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="create_time" label="发布时间" width="200" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" align="center">
              <template slot-scope="scope">
                <el-button @click="showNewsDialog(1,scope.row)" type="text" size="small">查看</el-button>
                <el-button v-if="createId_flag" class="red-btn" type="text" size="small" @click="delete_table_data(scope.row,'n')">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background v-if="n_total_number > n_page_size" class="pageing" @current-change="currentChange(n_page_index,'n')" :current-page.sync="n_page_index" :page-size="n_page_size" layout="prev, pager, next" :total="n_total_number">
          </el-pagination>
        </template>
        <template>
          <el-row class="manage_table_title">圈组教案</el-row>
          <el-table :data="teachingPlanData" border style="width: 100%" v-loading="t_loading">
            <el-table-column fixed prop="name" label="教案名称" width="360" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="教案类型" width="160" align="center" show-overflow-tooltip>
              <template slot-scope="scope">{{ scope.row.origin==0?'视频':(scope.row.origin==1?'资源':'试卷') }}</template>
            </el-table-column>
            <el-table-column prop="create_name" label="上传人" width="160" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="create_time" label="上传时间" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="160" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="manage_one_preview">
                  
                  <router-link v-if="scope.row.origin==0" :to="{path: '/home/openclassDetail', query: {id: scope.row.id}}">预览</router-link>
                  <router-link v-else-if="scope.row.origin==1" :to="{path: '/home/resourceDetail', query: {id: scope.row.id}}">预览</router-link>
                  <router-link v-else-if="scope.row.origin==2||scope.row.origin==4" :to="{path: '/home/albumPaper', query: {id: scope.row.id}}">预览</router-link>
                  <a v-else href="javascript:;">预览</a>
                </el-button>
                <el-button type="text" size="small" @click="download_teaching_plan(scope.row.id,scope.row.origin)">下载</el-button>
                <el-button v-if="login_user_id==scope.row.create_id" class="red-btn" type="text" size="small" @click="delete_table_data(scope.row,'t')">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background v-if="t_total_number > t_page_size" class="pageing" @current-change="currentChange(t_page_index,'t')" :current-page.sync="t_page_index" :page-size="t_page_size" layout="prev, pager, next" :total="t_total_number">
          </el-pagination>
        </template>
      </div>
      <el-dialog :title="news_add_or_show?'公告发布':'查看公告'" :visible.sync="newsVisible" width="800px" @close="closeNewsDialog">
        <el-form :model="newForm" ref="newForm" label-width="100px" class="demo-ruleForm manage_news_form">
          <el-form-item label="公告名称" prop="newsName" :rules="[{ required: news_add_or_show, message: '公告名称不能为空', trigger: 'blur'},{ min: 3, max: 20, message: '长度在 3 到 20 个字符', trigger: 'blur' }]">
            <el-input :readonly="news_add_or_show==false" v-model="newForm.newsName" maxlength="20" placeholder="请输入3到20个字符"></el-input>
          </el-form-item>
          <el-form-item label="公告内容" prop="newsComment" :rules="[{ required: news_add_or_show, message: '公告内容不能为空', trigger: 'blur'}]">
            <el-input :readonly="news_add_or_show==false" type="textarea" :rows="5" resize="none" v-model.trim="newForm.newsComment" maxlength="200" placeholder="请输入公告,不超200个字符">
            </el-input>
            <span class="numberWord">
              <i>{{ newForm.newsComment.length }}</i>/200</span>
          </el-form-item>
          <el-form-item v-if="news_add_or_show">
            <el-button size="small" @click="resetForm('newForm')">重置</el-button>
            <el-button type="primary" size="small" @click="submitForm('newForm')">提交</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>

      <el-dialog class="video_dialog i_join_dialog" :title="resource_type=='v'?'选择视频':(resource_type=='p'?'选择试卷':'选择资源')" :visible.sync="dialogFlag" width="800px" @close="close_i_dialog">
        <el-row>
          <el-col :span="8">
            <el-input :placeholder="resource_type=='v'?'搜索视频名':(resource_type=='p'?'搜索试卷名':'搜索资源名')" class="input-with-select" size="small" v-model="keyword" @keyup.enter.native="searchKeywords">
              <el-button slot="append" icon="el-icon-search" @click="searchKeywords"></el-button>
            </el-input>
          </el-col>
        </el-row>
        <template>
          <el-table ref="multipleTable" :data="i_table_data" border tooltip-effect="dark" style="width: 100%" @selection-change="getIdStringChecked">
            <el-table-column type="selection" width="35" align="center">
            </el-table-column>
            <template v-if="resource_type=='v'">
              <el-table-column prop="video_name" label="视频名" width="200" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="category" label="视频分类" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="profile" label="视频信息" width="200" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="create_time" label="上传时间" width="200" align="center" show-overflow-tooltip>
              </el-table-column>
            </template>
            <template v-if="resource_type=='p'">
              <el-table-column prop="name" label="试卷名" width="300" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="category" label="试卷分类" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column prop="create_time" label="上传时间" width="300" align="center" show-overflow-tooltip>
              </el-table-column>
            </template>
            <template v-if="resource_type=='r'">
              <el-table-column prop="name" label="资源名" width="200" align="center" show-overflow-tooltip>
              </el-table-column>
              <el-table-column label="资源分类" align="center" show-overflow-tooltip>
                <template slot-scope="scope">{{ scope.row.category==""?'暂无绑定资源分类':scope.row.category }}</template>
              </el-table-column>
              <el-table-column label="资源类型" width="200" align="center" show-overflow-tooltip>
                <template slot-scope="scope">{{ file_type_arr[scope.row.file_type - 1] }}</template>
              </el-table-column>
              <el-table-column prop="create_time" label="上传时间" width="200" align="center" show-overflow-tooltip>
              </el-table-column>
            </template>
          </el-table>
          <el-pagination background v-if="i_total_number > i_page_size" class="pageing" @current-change="currentChange(i_page_index,'i')" :current-page.sync="i_page_index" :page-size="i_page_size" layout="prev, pager, next" :total="i_total_number">
          </el-pagination>
          <div class="group-add-tableBtns">
            <el-button size="small" @click="toggleSelection()">取消选中</el-button>
            <el-button size="small" type="primary" @click="sureSelect(i_group_id,i_checked_idString)">确定</el-button>
          </div>
        </template>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      login_user_id: this.$store.getters.userInfo.id,
      group_id: this.$route.query.id,
      n_loading: true,
      t_loading: true,
      group_name: "",
      createId_flag: false,
      n_page_index: 1,
      n_page_size: 7,
      n_total_number: 0,
      order_type: "time",
      newsData: [],
      newsVisible: false,
      newForm: {
        newsName: "",
        newsComment: ""
      },
      news_add_or_show: true,
      t_page_index: 1,
      t_page_size: 7,
      t_total_number: 0,
      teachingPlanData: [],
      // 以下是关联资源：
      file_type_arr: ["文档", "日志", "图片", "压缩文件", "音频文件", "视频", "应用程序", "其他"],
      i_join_url: {
        video_url: "/api/video/video_list",
        paper_url: "/api/test/test",
        resource_url: "/api/resource/resource"
      },
      resource_type: "",
      i_page_index: 1,
      i_page_size: 5,
      i_total_number: 0,
      i_group_id: "",
      i_checked_idString: "", //checkbox选中的资源id值组成的字符串
      keyword: "",
      dialogFlag: false,
      i_table_data: [],
      video_group_size: 10,
      resource_group_size: 5,

      percentage: 0, //文件上传的实时进度
      upload_files_loading: false,
      upload_group_id: 0,
      statusText: {
        success: "上传成功",
        error: "上传出错",
        uploading: "正在上传...",
        paused: "暂停",
        waiting: "等待上传"
      },
      uploadOptions: {
        target: this.BASE_URL + "/api/resource/res_upload",
        testChunks: false,
        headers: { Authorization: `Bearer ` + this.$g.access_token }
      }
    };
  },
  created() {
    this.get_group();
    this.get_news();
    this.get_teaching_plan();
  },
  methods: {
        //跳转页面,_id资源的id，_origin：0去视频详情页，1去资源详情页
    goPath(_id, _origin) {
         if (_origin == 0) {
            this.$router.push({
              path: "/home/openclassDetail",
              query: { id: _id }
            });
          } else {
         this.$router.push({
              path: "/home/resourceDetail",
              query: { id: _id }
            });
          }
    },
    get_group() {
      let success = res => {
        this.group_name = res.data[0].name;
        this.login_user_id == res.data[0].create_id
          ? (this.createId_flag = true)
          : (this.createId_flag = false);
      };
      this.$ajax({
        url: "/api/group/group_list",
        method: "get",
        params: {
          id: this.group_id,
          flag: "array"
        },
        func: { success: success }
      });
    },
    get_news() {
      let success = res => {
        this.newsData = res.data.data;
        this.n_loading = false;
        this.n_page_index = parseInt(res.data.page_index);
        this.n_total_number = parseInt(res.data.data_sum);
      };
      this.$ajax({
        url: "/api/group/group_something",
        method: "get",
        params: {
          group_id: this.group_id,
          type: 4,
          page: this.n_page_index,
          size: this.n_page_size,
          order_type: this.order_type,
          data_type: 2
        },
        func: { success: success }
      });
    },
    showNewsDialog(type, _news) {
      type == 0
        ? (this.news_add_or_show = true)
        : (this.news_add_or_show = false);
      this.newsVisible = true;
      if (_news != undefined) {
        this.newForm.newsName = _news.name;
        this.newForm.newsComment = _news.content;
      }
    },
    closeNewsDialog() {
      this.resetForm("newForm");
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.sendNews();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    sendNews() {
      let success = res => {
        this.get_news();
        this.newsVisible = false;
        this.$message.success(res.msg);
      };
      this.$ajax({
        url: "/api/group/group_something",
        method: "post",
        data: {
          group_id: this.group_id,
          origin: 3,
          name: this.newForm.newsName,
          content: this.newForm.newsComment,
          create_id: this.login_user_id
        },
        func: { success: success }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    delete_table_data(row, type) {
      let confirm_tips, params;
      if (type == "n") {
        confirm_tips = "确定删除此公告吗?";
        params = {
          group_news_id: row.id,
          origin: 3
        };
      } else if (type == "t") {
        confirm_tips = "确定删除此教案吗?";
        params = {
          origin: row.origin,
          group_id: this.group_id,
          resource_id: row.id
        };
      }
      this.$confirm(confirm_tips, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "confirm-them"
      })
        .then(() => {
          this.sure_delete_table(params, type);
        })
        .catch(() => { });
    },
    sure_delete_table(_params, _type) {
      let success = res => {
        _type == "n" ? this.get_news() : this.get_teaching_plan();
        this.$message.success(res.msg);
      };
      this.$ajax({
        url: "/api/group/group_something",
        method: "delete",
        params: _params,
        func: { success: success }
      });
    },

    get_teaching_plan() {
      let success = res => {
        this.teachingPlanData = res.data.data;
        // console.log(this.teachingPlanData)
        this.t_loading = false;
        this.t_page_index = parseInt(res.data.page_index);
        this.t_total_number = parseInt(res.data.data_sum);
      };
      this.$ajax({
        url: "/api/group/group_something",
        method: "get",
        params: {
          group_id: this.group_id,
          type: 2,
          page: this.t_page_index,
          size: this.t_page_size,
          order_type: this.order_type,
          data_type: 2
        },
        func: { success: success }
      });
    },
    download_teaching_plan(id, origin) {
      switch (origin) {
        case 0:
          window.location.href =
            this.BASE_URL +
            "/index/openclass/videodownload?id=" +
            id +
            "&type=0&userid=" +
            this.login_user_id;
          break;
        case 1:
          window.location.href =
            this.BASE_URL +
            "/index/resource/resourcedownload?id=" +
            id +
            "&type=1&userid=" +
            this.login_user_id;
          break;
        default:
          break;
      }
    },
    fileProgress() {
      this.percentage = parseInt(this.$refs.uploader.uploader.progress() * 100);
    },
    fileSuccess(rootFile, file, message, chunk) {
      var mess = eval("(" + message + ")");
       mess = handleResponseData(mess);
      var params = {
        file_path: mess.data.file_path,
        file_type: mess.data.file_type,
        file_name: mess.data.file_name,
        post_fix: mess.data.post_fix,
        group_id: this.upload_group_id
      };
      let success = res => {
        this.upload_files_loading = false;
        this.get_teaching_plan();
        this.$message.success(res.msg);
      };
      this.$ajax.post("/api/group/bind_resource", params, {
        func: { success: success }
      });
    },
    fileFail(rootFile, file, message, chunk) {
      var mess = eval("(" + message + ")");
      if (parseInt(mess.error) === 401 && this.uploadRetryTimes > 0) {
        let callbcak = data => {
          this.uploadRetryTimes--;
          this.$refs.uploader.uploader.retry(file);
        };
        this.get_access_token(callbcak);
      } else {
        this.$message.error(mess.msg);
      }
    },
    open_dialog(id_val, type) {
      this.resource_type = type;
      this.i_group_id = id_val;
      this.keyword = "";
      this.i_table_data = [];
      this.dialogFlag = true;
      this.searchKeywords();
    },
    getTableData(_url) {
      let _params = {};
      if (this.resource_type == "v") {
        _params = {
          create_id: this.login_user_id,
          video_name: this.keyword,
          page_index: this.i_page_index,
          length: this.video_group_size,
          flag: "home",
          page_size: this.i_page_size,
          other_authority: 1,
          status: 1
        };
      } else if (this.resource_type == "p") {
        _params = {
          user_id: this.login_user_id,
          keyword: this.keyword,
          page_index: this.i_page_index,
          page_size: this.i_page_size,
          authonity: 1,
          other_authority: 1,
          status: 1
        };
      } else if (this.resource_type == "r") {
        _params = {
          create_id: this.login_user_id,
          resource_name: this.keyword,
          page: this.i_page_index,
          size: this.resource_group_size,
          authonity: 1,
          other_authority: 1,
          status: 1,
          data_type: 2
        };
      }
      let success = res => {
        this.i_table_data = res.data.data;
        // console.log(res.data.data)
        this.i_page_index = parseInt(res.data.page_index);
        this.i_total_number = parseInt(res.data.data_sum);
      };
      this.$ajax({
        url: _url,
        method: "get",
        params: _params,
        func: { success: success }
      });
    },
    searchKeywords() {
      if (this.resource_type == "v") {
        this.getTableData(this.i_join_url.video_url);
      } else if (this.resource_type == "p") {
        this.getTableData(this.i_join_url.paper_url);
      } else if (this.resource_type == "r") {
        this.getTableData(this.i_join_url.resource_url);
      }
    },
    getIdStringChecked(val) {
      this.i_checked_idString = arrChangeString(val, "id");
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    sureSelect(group_id, resource_id) {
      let success = res => {
        this.dialogFlag = false;
        this.get_teaching_plan();
      };
      this.$ajax({
        url: "/api/group/group_something",
        method: "post",
        data: {
          origin:
            this.resource_type == "v"
              ? 0
              : this.resource_type == "p" ? 2 : 1,
          group_id: group_id,
          resource_id: resource_id,
          is_share: 1
        },
        func: { success: success }
      });
    },
    close_i_dialog() {
      this.i_page_index = 1;
      this.i_page_size = 5;
      this.i_total_number = 0;
      this.resource_type = "";
      this.keyword = "";
      this.i_table_data = [];
    },
    currentChange(val, type) {
      if (type == "n") {
        this.n_page_index = val;
        this.get_news();
      } else if (type == "t") {
        this.t_page_index = val;
        this.get_teaching_plan();
      } else if (type == "i") {
        this.i_page_index = val;
        this.searchKeywords();
      }
    }
  }
};
</script>